export default __webpack_public_path__ + "static/media/admission05.668bc3a5.png";